import { useCallback, useEffect, useMemo, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import { Tooltip } from "antd";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "./index.css";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const options = {
  cMapUrl: "cmaps/",
  cMapPacked: true,
  standardFontDataUrl: "standard_fonts/",
};
function PDFPageviewer(props) {
  const { pdfUrl, allPageInOne, pdfPassword, isLibraryView, parentComponent } =
    props;
  // const [isFullScreen, setIsFullScreen] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageloading, setPageloading] = useState(false);
  const [scale, setScale] = useState(1.1);
  const [password, setPassword] = useState(pdfPassword);
  const [pDFError, setPDFError] = useState(null);
  const onDocumentLoadSuccess = useCallback(
    ({ numPages }) => {
      setPDFError(null);
      setNumPages(numPages);
      setPageNumber(1);
    },
    [pdfUrl]
  );
  useEffect(() => {
    setPassword(pdfPassword);
  }, [pdfPassword]);
  // const toggleFullScreen = () => {
  //   if (!isFullScreen) {
  //     console.log("fullscreen", isFullScreen, document.documentElement);
  //     if (document.documentElement.requestFullscreen) {
  //       document.documentElement.requestFullscreen();
  //     } else if (document.documentElement.mozRequestFullScreen) {
  //       document.documentElement.mozRequestFullScreen();
  //     } else if (document.documentElement.webkitRequestFullscreen) {
  //       document.documentElement.webkitRequestFullscreen();
  //     } else if (document.documentElement.msRequestFullscreen) {
  //       document.documentElement.msRequestFullscreen();
  //     }
  //   } else {
  //     console.log("fullscreen", isFullScreen);
  //     if (document.exitFullscreen) {
  //       document.exitFullscreen();
  //     } else if (document.mozCancelFullScreen) {
  //       document.mozCancelFullScreen();
  //     } else if (document.webkitExitFullscreen) {
  //       document.webkitExitFullscreen();
  //     } else if (document.msExitFullscreen) {
  //       document.msExitFullscreen();
  //     }
  //   }
  //   setIsFullScreen(!isFullScreen);
  // };
  const changePage = (offset) => {
    setPageloading(true);
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  };

  const previousPage = () => {
    changePage(-1);
  };

  const nextPage = () => {
    changePage(1);
  };
  const file = useMemo(
    () => ({
      url: pdfUrl,
    }),
    [pdfUrl]
  );
  const handleScale = (type) => {
    if (type == "reset") {
      setScale(1.1);
    } else if (type == "plus") {
      setScale(Number(scale) + 0.1);
    } else {
      setScale(Number(scale) - 0.1);
    }
  };
  const renderDocument = () => {
    return (
      <>
        <Document
          className={`pdf-document-viewer ${!pageloading ? "pdf-loaded" : ""}`}
          file={file}
          onPassword={(callback) => callback(password)}
          onContextMenu={(e) => e.preventDefault()}
          loading={<div className="pdfLoadingContainer"></div>}
          externalLinkRel="_blank"
          externalLinkTarget="_blank"
          error={
            <div className="pdfErrorContainer">Failed to load PDF file.!</div>
          }
          onLoadError={(error) => {
            setPDFError(error);
          }}
          options={options}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          {allPageInOne ? (
            Array.from(new Array(numPages), (el, index) => (
              <div
                key={`page_container_${index + 1}`}
                className="pdf-page-container"
              >
                <Page
                  scale={scale}
                  width={1000}
                  renderAnnotationLayer={true}
                  renderTextLayer={true}
                  onGetAnnotationsSuccess={(annotations) => {
                    console.log(annotations, "annotations");
                  }}
                  onGetAnnotationsError={(error) =>
                    console.log("annotations! " + error.message)
                  }
                  loading={<div className="pdfLoadingContainer"></div>}
                  onRenderSuccess={() => {
                    setPageloading(false);
                  }}
                  externalLinkTarget="_blank"
                  externalLinkRel="_blank"
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                />
                <div className="pdf-page-number-indicator">
                  Page {index + 1} of {numPages}
                </div>
              </div>
            ))
          ) : (
            <Page
              scale={scale}
              width={1000}
              canvasBackground={"white"}
              renderAnnotationLayer={true}
              renderTextLayer={true}
              onGetAnnotationsSuccess={(annotations) => {
                console.log(annotations, "annotations");
              }}
              onGetAnnotationsError={(error) =>
                console.error("annotations! " + error.message)
              }
              loading={<div className="pdfLoadingContainer"></div>}
              onRenderSuccess={() => {
                setPageloading(false);
              }}
              externalLinkTarget="_blank"
              externalLinkRel="_blank"
              pageNumber={pageNumber}
            />
          )}
        </Document>
        {allPageInOne ? (
          <div
            className={
              isLibraryView
                ? parentComponent === "AssetViewerModal"
                  ? "pdf-button-container-library-modal"
                  : parentComponent === "PlannerViewHome"
                  ? "pdf-button-container-library-planner"
                  : "pdf-button-container-library"
                : "pdf-button-container"
            }
          >
            <div></div>
            <div>
              {pDFError == null ? (
                <div className="pdf-zoom-controls">
                  <Tooltip title="Zoom Out">
                    <Button
                      className="pdf-zoom-button"
                      onClick={() => handleScale("minus", -10)}
                    >
                      −
                    </Button>
                  </Tooltip>
                  <Tooltip title="Reset to Original Size">
                    <Button
                      className="pdf-zoom-button"
                      onClick={() => handleScale("reset", 0)}
                    >
                      ⟲
                    </Button>
                  </Tooltip>
                  <Tooltip title="Zoom In">
                    <Button
                      className="pdf-zoom-button"
                      onClick={() => handleScale("plus", +10)}
                    >
                      +
                    </Button>
                  </Tooltip>
                </div>
              ) : null}
            </div>
            <div></div>
          </div>
        ) : (
          <div className="px-3 d-flex flex-row justify-content-between align-items-center mt-2 w-100">
            <div className="pdf-page-info">
              Page {pageNumber || (numPages ? 1 : "--")} of {numPages || "--"}
            </div>
            <div className="pdf-zoom-controls">
              <Tooltip title="Zoom Out">
                <Button
                  className="pdf-zoom-button"
                  onClick={() => handleScale("minus", -10)}
                >
                  −
                </Button>
              </Tooltip>
              <Tooltip title="Reset to Original Size">
                <Button
                  className="pdf-zoom-button"
                  onClick={() => handleScale("reset", 0)}
                >
                  ⟲
                </Button>
              </Tooltip>
              <Tooltip title="Zoom In">
                <Button
                  className="pdf-zoom-button"
                  onClick={() => handleScale("plus", +10)}
                >
                  +
                </Button>
              </Tooltip>
            </div>
            <div className="pdf-navigation-controls">
              <Button
                className="pdf-nav-button"
                disabled={pageNumber <= 1}
                onClick={previousPage}
              >
                ← Previous
              </Button>
              <Button
                className="pdf-nav-button"
                disabled={pageNumber >= numPages}
                onClick={nextPage}
              >
                Next →
              </Button>
            </div>
          </div>
        )}
      </>
    );
  };
  return <>{renderDocument()}</>;
}

PDFPageviewer.propTypes = {
  pdfUrl: PropTypes.string,
  allPageInOne: PropTypes.bool,
  pdfPassword: PropTypes.string,
  isFullScreen: PropTypes.bool,
  setIsFullScreen: PropTypes.func,
  isLibraryView: PropTypes.bool,
  source: PropTypes.string,
  parentComponent: PropTypes.string,
};
export default PDFPageviewer;
